import React, { Fragment } from "react";
import PropTypes from "prop-types";

import { isEmptyObject } from "@helpers/utils";

import {
  Modal as MuiModal,
  Box,
  Link,
  FormControl,
  FormControlLabel,
  TextField,
  InputLabel,
  Select,
  MenuItem,
  FormHelperText,
  Typography
} from "@mui/material";

import ModalContentBox from "@mui-theme/styled/ModalContentBox";
import CloseModalBox from "@mui-theme/styled/CloseModalBox";
import ThemedButton from "@mui-theme/styled/ThemedButton";

import useOtpForm from "./useOtpForm";

const OtpForm = props => {
  const {
    open,
    state,
    toggle,
    isValidInput,
    canSubmitForm,
    handleInputChange,
    handleSubmit
  } = useOtpForm(props);

  
  const {
    otpRequested,
    otpCode,
    personalNumber,
    medium,
    fetching,
    inputErrors,
    serverMessage
  } = state;

  return (
    <MuiModal
      open={open}
      onClose={(_, reason) => {
        if (reason !== "backdropClick") {
          toggle();
        }
      }}
      sx={{
        overflow: "scroll"
      }}
    >
      <ModalContentBox
        sx={{
          width: { xs: "90%", sm: 400 },
          maxHeight: "96%"
        }}
      >
        <Box
          sx={{
            width: "100%",
            justifyContent: "flex-start"
          }}
        >
          <Box
            sx={{
              width: "100%",
              px: 2,
              alignItems: "flex-start"
            }}
          >
            <Typography variant="h4" color="common.black">
              {otpRequested ? "Engångskod" : "Ange personnummer"}
            </Typography>
          </Box>
          {!otpRequested && (
            <Box
              component="form"
              noValidate
              onKeyDown={e => {
                if (e.key === "Enter") {
                  e.preventDefault();
                  if (canSubmitForm && (!inputErrors || isEmptyObject(inputErrors))) {
                    handleSubmit();
                  }
                }
              }}
              sx={{
                width: "100%",
                alignItems: "flex-start",
                display: "flex",
                flexFlow: "column",
                px: 2
              }}
            >
              {/* User Id */}
              {/* <Typography variant="h6" sx={{ color: "primary.main", mb: "5px" }}>
                Person- eller organisationsnummer
              </Typography> */}
              <Box
                sx={{
                  width: "100%",
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                  mb: 2.5
                }}
              >
                <TextField
                  required
                  fullWidth
                  color={
                    isValidInput("personalNumber", personalNumber)
                      ? "success"
                      : "primary"
                  }
                  size="small"
                  id="personalNumber"
                  name="personalNumber"
                  autoComplete="personalNumber"
                  placeholder="ÅÅÅÅMMDD-NNNN"
                  value={personalNumber}
                  error={!!inputErrors?.personalNumber}
                  onChange={e => {
                    handleInputChange(e);
                  }}
                  helperText={inputErrors?.personalNumber || serverMessage?.text}
                  sx={{
                    width: "70%",
                    height: 40,
                    alignItems: "flex-start",
                    mb: 1,
                    "& fieldset": {
                      borderColor: isValidInput(
                        "personalNumber",
                        personalNumber
                      )
                        ? "#2e7d32"
                        : "rgba(0, 0, 0, 0.23)"
                    }
                  }}
                />
              </Box>
            </Box>
          )}
          {otpRequested && (
            <Box
              component="form"
              noValidate
              onKeyDown={e => {
                if (e.key === "Enter") {
                  e.preventDefault();
                  if (canSubmitForm && (!inputErrors || isEmptyObject(inputErrors))) {
                    handleSubmit();
                  }
                }
              }}
              sx={{
                width: "100%",
                alignItems: "flex-start",
                display: "flex",
                flexFlow: "column",
                px: 2
              }}
            >
              {/* OTP Code */}
              {/* <Typography variant="h6" sx={{ color: "primary.main", mb: "5px" }}>
                Engångskod
              </Typography> */}
              <Typography
                variant="body2"
                align="left"
                sx={{ color: "text.secondary", mb: "15px" }}
              >
                Om du är med i systemet får du en engångskod till{" "}
                {medium === "email" ? "din e-post" : "ditt telefonnummer"}. Ange
                koden nedan.
              </Typography>
              <Box
                sx={{
                  width: "100%",
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                  mb: 1.5
                }}
              >
                <TextField
                  required
                  fullWidth
                  color={
                    isValidInput("otpCode", otpCode) ? "success" : "primary"
                  }
                  size="small"
                  id="otpCode"
                  name="otpCode"
                  autoComplete="otpCode"
                  placeholder="XXXXXX"
                  value={otpCode}
                  error={!!inputErrors?.otpCode}
                  onChange={e => {
                    handleInputChange(e);
                  }}
                  helperText={inputErrors?.otpCode || serverMessage?.text}
                  sx={{
                    width: "49%",
                    height: 40,
                    alignItems: "flex-start",
                    mb: 1,
                    "& fieldset": {
                      borderColor: isValidInput("otpCode", otpCode)
                        ? "#2e7d32"
                        : "rgba(0, 0, 0, 0.23)"
                    }
                  }}
                />
              </Box>
            </Box>
          )}
        </Box>
        <CloseModalBox
          sx={{
            px: 2
          }}
        >
          <ThemedButton
            variant="outlined"
            onClick={toggle}
            sx={{
              minWidth: "unset",
              width: 100
            }}
          >
            Avbryt
          </ThemedButton>
          <ThemedButton
            variant="contained"
            loading={fetching}
            disabled={
              !canSubmitForm || (inputErrors && !isEmptyObject(inputErrors))
            }
            onClick={handleSubmit}
            sx={{
              minWidth: "unset",
              width: 150
            }}
          >
            {otpRequested ? "Skicka kod" : "Begäran om kod"}
          </ThemedButton>
        </CloseModalBox>
      </ModalContentBox>
    </MuiModal>
  );
};

OtpForm.propTypes = {
  open: PropTypes.bool
};

export default OtpForm;
